import React from "react";

function IframePage(props) {
  const styles = {
    root: {},
  };

  return (
    <div style={styles.root}>
      <iframe
        title={props.title}
        src={props.src}
        style={{
          marginTop: "-20px",
          marginLeft: "-20px",
          overflow: "hidden",
          height: "100vh",
          width: "calc(100vw - 200px)",
        }}
        height="100%"
        width="100%"
      />
    </div>
  );
}

export default IframePage;